module.exports = __webpack_public_path__ + "img/avatar2.30767a15.png";